export const routerPaths = {
  canvas: 'canvas',
  bootstrap: 'bootstrap',
  home: 'home',
  checkout: 'checkout',
  notfound: 'notfound',
  profile: 'profile',
  domain: 'domain',
  manage: 'manage',
};
